'use client'

import React from 'react'
import Link from 'next/link'
import { Button as UIButton } from '@/components/Button'
// Local type definition to avoid import issues
type ButtonBlockProps = {
  id?: string
  blockType?: string
  blockName?: string
  label?: string
  variant?: 'default' | 'destructive' | 'ghost' | 'link' | 'black' | 'outline' | 'secondary'
  size?: 'clear' | 'default' | 'icon' | 'lg' | 'sm'
  href?: string
  newTab?: boolean
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
  className?: string
}

interface ButtonBlockComponentProps {
  label?: string
  variant?: 'default' | 'destructive' | 'ghost' | 'link' | 'black' | 'outline' | 'secondary'
  size?: 'clear' | 'default' | 'icon' | 'lg' | 'sm'
  href?: string
  newTab?: boolean
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
  className?: string
}

export const ButtonBlock: React.FC<ButtonBlockComponentProps> = ({
  label = 'Button',
  variant = 'default',
  size = 'default',
  href,
  newTab = false,
  type = 'button',
  disabled = false,
  className,
}) => {
  // If href is provided, render as a link
  if (href) {
    // Internal link
    if (href.startsWith('/') || href.startsWith('#')) {
      return (
        <Link href={href} className="inline-block">
          <UIButton
            variant={variant}
            size={size}
            disabled={disabled}
            className={className}
          >
            {label}
          </UIButton>
        </Link>
      )
    }
    
    // External link
    return (
      <a
        href={href}
        target={newTab ? '_blank' : undefined}
        rel={newTab ? 'noopener noreferrer' : undefined}
        className="inline-block"
      >
        <UIButton
          variant={variant}
          size={size}
          disabled={disabled}
          className={className}
        >
          {label}
        </UIButton>
      </a>
    )
  }

  // Regular button
  return (
    <UIButton
      type={type}
      variant={variant}
      size={size}
      disabled={disabled}
      className={className}
    >
      {label}
    </UIButton>
  )
}

export default ButtonBlock